import { PillGroup } from "@mantine/core"
import { useSearchParams } from "react-router-dom"

import { ViewItem } from "~/components/table/views/ViewItem"
import { useFindViews, ViewDto } from "~/gen/api"

type ViewsProps = {
  tableContext: string
}

const VIEW_ALL: ViewDto = {
  id: "all",
  organizationId: "",
  tableContext: "",
  createdAt: new Date(),
  updatedAt: new Date(),
  name: "All",
  filters: {},
  sorts: {},
  pinnedColumns: {},
  pinnedToDashboard: false,
}

export const Views = ({ tableContext }: ViewsProps) => {
  const [searchParams] = useSearchParams()
  const { data: views } = useFindViews({ tableContext })
  const currentView =
    views?.data?.views.find((view) => view.id === searchParams.get("viewId")) ??
    VIEW_ALL

  return (
    <PillGroup
      style={{
        whiteSpace: "nowrap",
        flexWrap: "nowrap",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <ViewItem
        id="all"
        name={VIEW_ALL.name}
        currentView={currentView}
        tableContext={tableContext}
        removeButton={false}
      />
      {views?.data?.views?.map(({ name, id, tableContext }) => (
        <ViewItem
          key={id}
          id={id}
          name={name}
          currentView={currentView}
          removeButton={true}
          tableContext={tableContext}
        />
      ))}
    </PillGroup>
  )
}
